import 'css-chunksrc/client/pages/projectPage/timeSheetPage/loader/allocation/list/styles.scss';export default {
  "main": "_main_11blw_1",
  "header": "_header_11blw_7",
  "iconBox": "_iconBox_11blw_18",
  "icon": "_icon_11blw_18",
  "openedIcon": "_openedIcon_11blw_34",
  "row": "_row_11blw_38",
  "avatar": "_avatar_11blw_45",
  "col": "_col_11blw_50",
  "name": "_name_11blw_59",
  "profession": "_profession_11blw_64",
  "recordList": "_recordList_11blw_69"
};